// src/api/notifications.js
import API from "../api";
import { getActiveRole } from "../utils/auth";

const activeRoleParam = () => {
  const role = getActiveRole();
  return role ? `?role=${role.toUpperCase()}` : '';
};

/** Fetch recent notifications for bell dropdown */
export const listNotifications = () =>
  API.get(`/notifications${activeRoleParam()}`).then((r) => r.data);

/** Paginated notification history */
export const listNotificationsPage = ({ page = 0, size = 50 } = {}) =>
  API.get(`/notifications/page${activeRoleParam()}`, { params: { page, size } }).then((r) => r.data);

/** Get unread notification count scoped to active role */
export const getUnreadCount = () =>
  API.get(`/notifications/unread-count${activeRoleParam()}`).then((r) => r.data.count);

/** Mark a single notification as read */
export const markRead = (id) =>
  API.post(`/notifications/${id}/read`).then((r) => r.data);

/** Mark all notifications as read */
export const markAllRead = () =>
  API.post("/notifications/read-all").then((r) => r.data);
